import { useState } from "react";
import email from './assets/email_vector.svg'
import wpp from './assets/whatsapp_vector.svg'
import openIcon from './assets/open.svg'
import closeIcon from './assets/close.svg'

const Contato = () => {
    return ( 
        <div className="contato" id='contato'>
            <div className="contato-left">
                <div className="contato-texts">
                    <h2 className="contato-title">Ficou com <span>alguma dúvida?</span></h2>
                    <p className="contato-description">Confira as respostas para as perguntas frequentes ou entre em contato conosco:</p>
                </div>
                <div className="contato-card">
                    <img src={email} alt="" className="contato-icon" />
                    <div className="contato-card-texts">
                        <h2 className="contato-card-title">Atendimento por <span>email</span></h2>
                        <p>Mande um e-mail agora para atendimento@ipjbr.com.br</p>
                    </div>
                </div>
                <div className="contato-card" onClick={() => window.open('https://api.whatsapp.com/send?phone=558006761000&text=Olá! Gostaria de tirar algumas dúvidas sobre o Instituto.', '_blank') }>
                    <img src={wpp} alt="" className="contato-icon" />
                    <div className="contato-card-texts">
                        <h2 className="contato-card-title">Atendimento por <span>Whatsapp</span></h2>
                        <p>Toque aqui para tirar suas dúvidas</p>
                    </div>
                </div>
            </div>
            <div className="contato-right">
                <FAQ />
            </div>
        </div>
    );
}

const FAQ = () => {
    const [open, setOpen] = useState(null)
    
    const items = [
            {
                "question": "O IPJ atende qualquer pessoa que esteja precisando de ajuda para lidar com a compulsão por jogos de azar?",
                "answer": "Sim. O IPJ está pronto para atender todas as demandas relacionadas ao acometimento de distúrbios provocados por compulsão ocasionados por apostas ou jogos de azar. "
            },
            {
                "question": "O atendimento no IPJ é gratuito?",
                "answer": "O atendimento no IPJ é custeado pelas empresas de apostas parceiras do Instituto. Mas o atendimento também pode ser realizado a qualquer pessoa, mesmo que ela não seja cliente de uma empresa de apostas parceira, onde será oferecido um plano de atendimento e seus respectivos valores."
            }, 
            {
                "question": "Como faço para ser atendido sendo cliente de uma empresa parceira?",
                "answer": "Você pode nos acionar através do link na página logada da empresa parceira, ou clicar em “atendimento imediato”, onde o contato será feito entre o Instituto para com a empresa."
            }, 
            {
                "question": "Como faço para ser atendido sem ser cliente de uma empresa de apostas parceira?",
                "answer": "Você pode clicar em “agende uma consulta” e conhecer nossos programas de atendimento."
            }, 
            {
                "question": "Como funcionam as salas de apoio?",
                "answer": "A sala de atendimento ao jogador funciona semanalmente com atendimento direcionado ao jogador.  Lá o jogador poderá se manter anônimo, com a tela e áudio fechados. Mas a interação com o profissional é sempre bem vinda. A sala de atendimento às famílias tem como objetivo auxiliar o familiar do jogador com compulsão que está com dificuldades em abordar o assunto dentro de casa."
            },
            {
                "question": "Posso frequentar a sala de apoio toda semana?",
                "answer": "Sim. O objetivo é manter o jogador longe do vício, e fazê-lo entender que jogo é entretenimento, e deve ser evitado quando escapa do controle e se torna o centro da sua vida."
            }
        ]
    
    return (
        <div className="faq">
            { items.map((question, idx) => (
                <div className="individual" onClick={() => setOpen( idx === open ? null :idx)} style={{height: idx === open ? `${window.innerWidth > 1200 ? '18vh' : '30vh'}` : '9vh'}}>
                    <h2>{question.question}</h2>
                    { idx === open && (
                        <span>{question.answer}</span>
                    )}
                    { (idx === open && (
                        <img src={closeIcon} alt="" className="open-close-icon" />
                    ) ) || (
                        <img src={openIcon} alt="" className="open-close-icon" />
                    )}
                </div>
            ))}
        </div>
    )
}
 
export default Contato;